/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";

export const titleCss = css`
  margin: 0;
  padding: 0 40px 24px;
  text-align: center;
`;
